import { motion } from "framer-motion";

const Contact = () => {
  return (
    <section id="contact" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="text-gray-500 text-sm font-semibold tracking-wider uppercase mb-3">
            Get In Touch
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-6 font-['Playfair_Display']">
            Visit Us in Mansfield
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We'd love to hear from you! Whether you're looking for a church home or have questions about our ministries, 
            feel free to reach out.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="bg-white rounded-xl shadow-lg p-8 mb-8 border border-gray-200">
              <h3 className="text-2xl font-bold text-black mb-6">Contact Information</h3>
              
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-xl text-black"></i>
                  </div>
                  <div className="ml-4">
                    <h4 className="font-semibold text-black mb-1">Address</h4>
                    <p className="text-gray-600">
                      Mansfield, Nottinghamshire<br />
                      United Kingdom
                    </p>
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center mr-4">
                    <i className="ri-phone-line text-xl text-black"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Phone</p>
                    <a href="tel:+447718134887" className="text-base font-semibold text-black hover:text-gray-700 transition-colors">
                      (+44) 7718134887
                    </a>
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center mr-4">
                    <i className="ri-mail-line text-xl text-black"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Email</p>
                    <a href="mailto:info@mansfieldpiwc.com" className="text-base font-semibold text-black hover:text-gray-700 transition-colors">
                      info@mansfieldpiwc.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="bg-white p-8 rounded-lg border border-gray-200 flex flex-col items-center justify-center"
          >
            <h3 className="text-2xl font-semibold text-black mb-4 text-center">
              Connect With Us
            </h3>
            <p className="text-gray-600 text-center mb-8">
              Follow us on social media to stay updated with our latest events and activities
            </p>
            <div className="flex gap-6">
              <a
                href="https://www.instagram.com/mansfieldpiwc"
                target="_blank"
                rel="noopener noreferrer"
                className="w-16 h-16 bg-gradient-to-br from-purple-600 via-pink-600 to-orange-500 rounded-xl flex items-center justify-center hover:scale-110 transition-transform cursor-pointer"
              >
                <i className="ri-instagram-line text-3xl text-white"></i>
              </a>
              <a
                href="https://www.facebook.com/mansfieldpiwc"
                target="_blank"
                rel="noopener noreferrer"
                className="w-16 h-16 bg-blue-600 rounded-xl flex items-center justify-center hover:scale-110 transition-transform cursor-pointer"
              >
                <i className="ri-facebook-fill text-3xl text-white"></i>
              </a>
              <a
                href="https://www.tiktok.com/@mansfieldpiwc"
                target="_blank"
                rel="noopener noreferrer"
                className="w-16 h-16 bg-black rounded-xl flex items-center justify-center hover:scale-110 transition-transform cursor-pointer"
              >
                <i className="ri-tiktok-fill text-3xl text-white"></i>
              </a>
            </div>
            <p className="text-gray-500 text-sm mt-6">@mansfieldpiwc</p>
          </motion.div>
        </div>

        <div className="mt-16 rounded-lg overflow-hidden shadow-lg h-96">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d38259.5!2d-1.1987!3d53.1472!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4879e89b5e1e5e5f%3A0x5d5e5e5e5e5e5e5e!2sMansfield%2C%20NG19%200DU%2C%20UK!5e0!3m2!1sen!2suk!4v1234567890"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Church Location - Mansfield, NG19 0DU"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default Contact;
